import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

import { credentialsManager } from "../auth";
import { Routes } from "../constants";
import logo from "../logo.png";
import fonts from "../style/fonts";
import { ThemeProps } from "../style/themes/types";
import { PrimaryButton, TransparentButton } from "./Buttons";

const HeaderLogo = styled.img`
  order: 0;
  flex-grow: 0;
  flex-shrink: 0;

  height: 44px;
  margin-top: 32px;
  margin-bottom: 32px;
  margin-left: 59px;
  margin-right: 95px;
`;

const HeaderMenu = styled.div<ThemeProps>`
  /* as flex item */
  order: 1;
  flex-grow: 1; /* fill any space not taken by the logo  */

  /* as flex container */
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: nowrap;
  align-items: center;

  color: ${props => props.theme.texts};
`;

const HeaderLeftMenu = styled.div<ThemeProps>`
  flex-grow: 1;
  flex-shrink: 0;

  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;

  gap: 1.7rem;

  ${fonts.small}

  & a {
    color: ${props => props.theme.titles};
  }
`;

const HeaderRightMenu = styled.div`
  flex-grow: 0;
  flex-shrink: 0;

  display: flex;
  column-gap: 1.44rem;
  margin-right: 4.93rem;
`;

interface HeaderProps {
  className?: string;
  logoSrc: string;
  loggedIn?: boolean;
  children: React.ReactNode[];
}

const Header = ({ className, logoSrc, loggedIn, children }: HeaderProps) => (
  <header className={className}>
    <HeaderLogo src={logoSrc} alt="logo" />
    <HeaderMenu>
      {loggedIn === true ? null : (
        <HeaderRightMenu>
          <TransparentButton>Log in</TransparentButton>
          <PrimaryButton>Regístrate</PrimaryButton>
        </HeaderRightMenu>
      )}
      <HeaderLeftMenu>{children}</HeaderLeftMenu>
    </HeaderMenu>
  </header>
);

const StyledHeader = styled(Header)`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
`;

export default function WalixHeader() {
  const [loggedIn, setLoggedIn] = useState(true);

  useEffect(() => {
    const userIsAuthenticated = credentialsManager.userIsAuthenticated();
    setLoggedIn(userIsAuthenticated);
  }, []);

  return (
    <StyledHeader logoSrc={logo} loggedIn={loggedIn}>
      <Link to={Routes.OPERADORES}>Operadores</Link>
      <Link to={Routes.PRODUCTS}>Paquetes</Link>
      <Link to={Routes.SOBRE_WALIX}>Sobre Walix</Link>
    </StyledHeader>
  );
}
